import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/shared/ErrorBoundary';
import Login from './components/Login';
import SuperAdminDashboard from './components/SuperAdminDashboard';
import DistrictAdminDashboard from './components/DistrictAdminDashboard';
import ParentDashboard from './components/ParentDashboard';
import PrivateRoute from './components/PrivateRoute';
import ResetPassword from './components/ResetPassword';
import ForgotPassword from './components/ForgotPassword';
import ForgotUsername from './components/ForgotUsername';
import RegisterParent from './components/RegisterParent';
import SchoolLunchApplicationForm from './components/shared/SchoolLunchApplicationForm';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<RegisterParent />} />
          <Route path="/forgot-username" element={<ForgotUsername />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/superadmin/*"
            element={
              <PrivateRoute requiredRole="superadmin">
                <SuperAdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/district-admin/*"
            element={
              <PrivateRoute requiredRoles={['district_admin', 'district_editor', 'district_user']}>
                <DistrictAdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/parent/*"
            element={
              <PrivateRoute requiredRole="parent">
                <ParentDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/school-lunch-test"
            element={
              <PrivateRoute requiredRole="parent">
                <div style={{ padding: '20px' }}>
                  <h1>School Lunch Application</h1>
                  <p>Complete this form to apply for free or reduced price school meals. The form will generate a PDF that matches the official Missouri School Lunch Application format.</p>
                  <SchoolLunchApplicationForm />
                </div>
              </PrivateRoute>
            }
          />
          <Route
            path="/*"
            element={<Navigate to="/login" replace />}
          />
          </Routes>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;

